import {
  ackSchema,
  aliasSchema,
  listAliasesResponseSchema,
  listMailboxesResponseSchema,
  mailboxSchema,
  mailboxWithCountsSchema,
  type Ack,
  type Alias,
  type AliasId,
  type CreateAliasRequest,
  type CreateMailboxRequest,
  type Mailbox,
  type MailboxId,
  type MailboxWithCounts,
  type UpdateMailboxRequest,
} from "@mailflare/shared";

import { apiRequest } from "@/lib/api-client";

export async function listMailboxes(): Promise<readonly MailboxWithCounts[]> {
  return listMailboxesResponseSchema.parse(await apiRequest<unknown>("/mailboxes")).mailboxes;
}

export async function getMailbox(mailboxId: MailboxId): Promise<MailboxWithCounts> {
  return mailboxWithCountsSchema.parse(
    await apiRequest<unknown>(`/mailboxes/${encodeURIComponent(mailboxId)}`),
  );
}

export async function createMailbox(body: CreateMailboxRequest): Promise<Mailbox> {
  return mailboxSchema.parse(await apiRequest<unknown>("/mailboxes", { method: "POST", body }));
}

export async function updateMailbox(
  mailboxId: MailboxId,
  body: UpdateMailboxRequest,
): Promise<Mailbox> {
  return mailboxSchema.parse(
    await apiRequest<unknown>(`/mailboxes/${encodeURIComponent(mailboxId)}`, {
      method: "PATCH",
      body,
    }),
  );
}

export async function deleteMailbox(mailboxId: MailboxId): Promise<Ack> {
  return ackSchema.parse(
    await apiRequest<unknown>(`/mailboxes/${encodeURIComponent(mailboxId)}`, { method: "DELETE" }),
  );
}

export async function listAliases(mailboxId: MailboxId): Promise<readonly Alias[]> {
  return listAliasesResponseSchema.parse(
    await apiRequest<unknown>(`/mailboxes/${encodeURIComponent(mailboxId)}/aliases`),
  ).aliases;
}

export async function createAlias(mailboxId: MailboxId, body: CreateAliasRequest): Promise<Alias> {
  return aliasSchema.parse(
    await apiRequest<unknown>(`/mailboxes/${encodeURIComponent(mailboxId)}/aliases`, {
      method: "POST",
      body,
    }),
  );
}

export async function deleteAlias(aliasId: AliasId): Promise<Ack> {
  return ackSchema.parse(
    await apiRequest<unknown>(`/aliases/${encodeURIComponent(aliasId)}`, { method: "DELETE" }),
  );
}
